import React, { useState } from 'react';
import { navigate, useAuth } from '../store';
import { api } from '../api';
import { Icon } from '../ui/Icon';
import { Field } from '../ui';

export function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  if (forgot) return <Forgot initial={username} onBack={() => setForgot(false)} />;
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError('');
    try { await login(username, password); } catch (err: any) { setError(err.message || 'Autentificare eșuată'); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <form className="box" onSubmit={submit}>
        <div className="brand"><div className="mark">D</div><div><span className="name">DocFlow</span><span className="sub">Registratură și management de documente</span></div></div>
        <div className="stack">
          <Field label="Utilizator sau e-mail"><input className="input" autoFocus value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" /></Field>
          <Field label="Parolă"><input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" /></Field>
          {error && <div className="banner warn"><Icon name="alert" />{error}</div>}
          <button className="btn primary lg" disabled={busy || !username || !password} style={{ justifyContent: 'center', marginTop: 6 }}>{busy ? 'Se autentifică…' : 'Intră în aplicație'}</button>
          <button type="button" className="link-btn" onClick={() => setForgot(true)}>Am uitat parola</button>
        </div>
      </form>
    </div>
  );
}

function Brand() {
  return <div className="brand"><div className="mark">D</div><div><span className="name">DocFlow</span><span className="sub">Registratură și management de documente</span></div></div>;
}

function Forgot({ initial, onBack }: { initial: string; onBack: () => void }) {
  const [login, setLogin] = useState(initial);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(''); setMsg('');
    try { const r = await api.post<{ message: string }>('/api/auth/forgot', { login: login.trim() }); setMsg(r.message); }
    catch (err: any) { setError(err.message || 'Cererea nu a putut fi trimisă'); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <form className="box" onSubmit={submit}>
        <Brand />
        <div className="stack">
          <div><b>Resetare parolă</b><div className="muted small" style={{ marginTop: 4 }}>Introduceți utilizatorul sau adresa de e-mail. Veți primi pe e-mail un link valabil o oră pentru a alege o parolă nouă.</div></div>
          <Field label="Utilizator sau e-mail"><input className="input" autoFocus value={login} onChange={e => setLogin(e.target.value)} autoComplete="username" /></Field>
          {msg && <div className="banner"><Icon name="mail" />{msg}</div>}
          {error && <div className="banner warn"><Icon name="alert" />{error}</div>}
          <button className="btn primary lg" disabled={busy || !login.trim() || !!msg} style={{ justifyContent: 'center', marginTop: 6 }}>{busy ? 'Se trimite…' : 'Trimite linkul de resetare'}</button>
          <button type="button" className="link-btn" onClick={onBack}>Înapoi la autentificare</button>
        </div>
      </form>
    </div>
  );
}

export function ResetPassword({ token }: { token: string }) {
  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const weak = p1.length > 0 && (p1.length < 8 || !/[a-zA-Z]/.test(p1) || !/[0-9]/.test(p1));
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (p1 !== p2) { setError('Parolele nu coincid'); return; }
    setBusy(true); setError('');
    try { await api.post('/api/auth/reset', { token, password: p1 }); setDone(true); }
    catch (err: any) { setError(err.message || 'Parola nu a putut fi schimbată'); } finally { setBusy(false); }
  };
  return (
    <div className="login">
      <form className="box" onSubmit={submit}>
        <Brand />
        {done ? (
          <div className="stack">
            <div className="banner"><Icon name="check" />Parola a fost schimbată. Vă puteți autentifica cu parola nouă.</div>
            <button type="button" className="btn primary lg" style={{ justifyContent: 'center' }} onClick={() => navigate('/')}>Mergi la autentificare</button>
          </div>
        ) : (
          <div className="stack">
            <div><b>Alegeți o parolă nouă</b><div className="muted small" style={{ marginTop: 4 }}>Cel puțin 8 caractere, cu litere și cifre.</div></div>
            <Field label="Parola nouă"><input className="input" type="password" autoFocus value={p1} onChange={e => setP1(e.target.value)} autoComplete="new-password" /></Field>
            <Field label="Repetați parola"><input className="input" type="password" value={p2} onChange={e => setP2(e.target.value)} autoComplete="new-password" /></Field>
            {weak && <div className="muted small">Parola trebuie să aibă cel puțin 8 caractere, litere și cifre.</div>}
            {error && <div className="banner warn"><Icon name="alert" />{error}</div>}
            <button className="btn primary lg" disabled={busy || !p1 || !p2 || weak} style={{ justifyContent: 'center', marginTop: 6 }}>{busy ? 'Se salvează…' : 'Schimbă parola'}</button>
            <button type="button" className="link-btn" onClick={() => navigate('/')}>Înapoi la autentificare</button>
          </div>
        )}
      </form>
    </div>
  );
}
